module.exports = __webpack_public_path__ + "img/notifications.0a9e1efc.svg";